package io.horion.cv.components.forms

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import io.horion.cv.components.widgets.FormActionButtons
import io.horion.cv.components.widgets.TextFormField
import io.horion.cv.models.ListState
import org.jetbrains.compose.web.css.px

@Composable
fun ListForm(
    state: ListState,
    onDelete: () -> Unit,
    onComplete: () -> Unit,
) {
    Column(
        modifier = Modifier.fillMaxWidth(),
        verticalArrangement = Arrangement.spacedBy(25.px)
    ) {
        TextFormField(
            label = "Titre",
            value = state.title,
            onValueChange = { state.title = it },
            modifier = Modifier.fillMaxWidth(),
        )

        FormActionButtons(
            onDelete = onDelete,
            onComplete = onComplete
        )
    }
}